"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = _interopRequireWildcard(require("../Input"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Input for numbers and Currencies with possibilities to add prefix/suffix and optional thousand-seperators.
 */
var CurrencyInput = _react["default"].forwardRef(function (_ref, ref) {
  var _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === void 0 ? null : _ref$prefix,
      _ref$delimiter = _ref.delimiter,
      delimiter = _ref$delimiter === void 0 ? " " : _ref$delimiter,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      props = _objectWithoutProperties(_ref, ["prefix", "delimiter", "options"]);

  return _react["default"].createElement(_Input["default"], _extends({
    type: "tel",
    options: _objectSpread2({}, options, {
      numeral: true,
      delimiter: delimiter,
      prefix: prefix
    }),
    ref: ref
  }, props));
});
/* TODO: Should have a pattern so that we get number-keyboard: added this: https://stackoverflow.com/questions/6178556/phone-numeric-keyboard-for-text-input */


CurrencyInput.propTypes = _objectSpread2({}, _Input.InputPropTypes, {
  id: _propTypes["default"].string.isRequired,
  suffix: _propTypes["default"].string,
  prefix: _propTypes["default"].string,
  thousandsSeparatorSymbol: _propTypes["default"].string
});
CurrencyInput.defaultProps = {
  suffix: "",
  prefix: "",
  thousandsSeparatorSymbol: " "
};
var _default = CurrencyInput;
exports["default"] = _default;